import { render } from "./DonationBookingsTab.vue?vue&type=template&id=45d8cb27"
import script from "./DonationBookingsTab.vue?vue&type=script&lang=js"
export * from "./DonationBookingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__